var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-autocomplete",
    _vm._b(
      {
        attrs: {
          loading: _vm.loading,
          "search-input": _vm.entitiesSearchQuery,
          items: _vm.getEntities,
          outlined: "",
          dense: "",
          filter: _vm.customFilter,
          value: _vm.value,
          label: _vm.label,
          rules: _vm.required ? [v => !!v || "Entité requise"] : []
        },
        on: {
          "update:searchInput": function($event) {
            _vm.entitiesSearchQuery = $event
          },
          "update:search-input": function($event) {
            _vm.entitiesSearchQuery = $event
          },
          input: _vm.handleInputChange
        },
        scopedSlots: _vm._u([
          {
            key: "item",
            fn: function({ item }) {
              return [
                _vm._v(
                  "\n    " + _vm._s(item.id + " - " + item.short_name) + "\n  "
                )
              ]
            }
          },
          {
            key: "selection",
            fn: function(data) {
              return [
                _c(
                  "v-chip",
                  _vm._b(
                    {
                      attrs: { value: data.selected, close: "", small: "" },
                      on: {
                        "click:close": function($event) {
                          return _vm.handleInputChange(null)
                        }
                      }
                    },
                    "v-chip",
                    data.attrs,
                    false
                  ),
                  [_vm._v("\n      " + _vm._s(data.item.id) + "\n    ")]
                )
              ]
            }
          }
        ])
      },
      "v-autocomplete",
      _vm.$attrs,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }